import { ColorTheme } from "./Theme.interface";

export const LightColorTheme: ColorTheme = {
  primary: "#000000",
  tint: "#357EC7",
  surface: "lightgray",
  onSurface: "white",
  background: "#ecf0f1",
  navigationBackground: "#357EC7",
};
